import { render } from "./LegendTable.vue?vue&type=template&id=b6926144&scoped=true&lang=pug"
import script from "./LegendTable.vue?vue&type=script&lang=ts"
export * from "./LegendTable.vue?vue&type=script&lang=ts"

import "./LegendTable.vue?vue&type=style&index=0&id=b6926144&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b6926144"

export default script